export const AUTH_DENIED = 'AUTH_DENIED';
export const EXPIRE = "EXPIRE";
export const ENCODING_FAIL = "ENCODING_FAIL";
export const UPLOAD_FAIL = "UPLOAD_FAIL";
export const DELETE = "DELETE";
export const LOADING = "LOADING";
export const ADULT_LOCK = "ADULT_LOCK";
export const LOCK = "LOCK";
export const BLIND = "BLIND";
export const ADULT = "ADULT";
export const SUCCEED = "SUCCEED";
